import { memo } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, BoxProps, Toolbar } from '@mui/material';
// config
import { HEADER } from '../../../config-global';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
//
import { navConfig, navConfigNonAdmin } from './config-navigation';
import { useAuthContext } from '../../../auth/useAuthContext';

// ----------------------------------------------------------------------

export default function NavHorizontal() {
  const { user } = useAuthContext();
  const currentNavConfig = user?.role === 'SuperAdmin' ? navConfig : navConfigNonAdmin;

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: HEADER.H_DASHBOARD_DESKTOP },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          height: 1,
          px: { lg: 2 },
        }}
      >
        <NavSectionHorizontal data={currentNavConfig} />
      </Toolbar>

      <Shadow />
    </Box>
  );
}

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        width: 1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
